import { createStructuredSelector } from 'reselect'

import {
  EVALUATION_DETAIL_LIST,
  EVALUATION_DETAIL_LIST_SUCCESS, 
  EVALUATION_DETAIL_LIST_ERROR,
  EVALUATION_DETAIL_PAGE_SET,
  EVALUATION_DETAIL_SEARCH_SET,
  EVALUATION_DETAIL_SEARCH_CHANGE,
  EVALUATION_DETAIL_SEARCH_EVALUATION,
  EVALUATION_DETAIL_SEARCH_EVALUATION_SUCCESS,
  EVALUATION_DETAIL_SEARCH_EVALUATION_ERROR, 
  EVALUATION_DETAIL_SEARCH_ANSWER,
  EVALUATION_DETAIL_SEARCH_ANSWER_SUCCESS,
  EVALUATION_DETAIL_SEARCH_ANSWER_ERROR, 
  EVALUATION_DETAIL_SEARCH_DOCUMENT,
  EVALUATION_DETAIL_SEARCH_DOCUMENT_SUCCESS,
  EVALUATION_DETAIL_SEARCH_DOCUMENT_ERROR, 
  EVALUATION_DETAIL_ADD_SET,
  EVALUATION_DETAIL_ADD_MODAL_SET,
  EVALUATION_DETAIL_ADD,
  EVALUATION_DETAIL_ADD_SUCCESS,
  EVALUATION_DETAIL_ADD_ERROR,
  EVALUATION_DETAIL_ADD_CHANGE,
  EVALUATION_DETAIL_DETAIL,
  EVALUATION_DETAIL_DETAIL_SUCCESS,
  EVALUATION_DETAIL_DETAIL_ERROR,
  EVALUATION_DETAIL_VIEW_MODAL_SET,
  EVALUATION_DETAIL_EDIT_CHANGE,
  EVALUATION_DETAIL_EDIT_MODAL_SET,
  EVALUATION_DETAIL_UPDATE,
  EVALUATION_DETAIL_UPDATE_SUCCESS,
  EVALUATION_DETAIL_UPDATE_ERROR,
  EVALUATION_DETAIL_VIEW_TAB_SET
} from '../../actions';

export const NAME = 'evaluation_detail';

export const EvaluationDetailList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: EVALUATION_DETAIL_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const EvaluationDetailListSuccess = (data) => ({
  type: EVALUATION_DETAIL_LIST_SUCCESS,
  payload: data
});

export const EvaluationDetailListError = (error) => ({
  type: EVALUATION_DETAIL_LIST_ERROR,
  payload: error
});

export const EvaluationDetailPageSet = (data) => ({
  type: EVALUATION_DETAIL_PAGE_SET,
  payload: data
});

export const EvaluationDetailSearchSet = (data) => ({
  type: EVALUATION_DETAIL_SEARCH_SET,
  payload: data
});

export const EvaluationDetailSearchChangeSet = (data) => ({
  type: EVALUATION_DETAIL_SEARCH_CHANGE,
  payload: data
});

export const EvaluationDetailSearchEvaluation = (data) => ({
  type: EVALUATION_DETAIL_SEARCH_EVALUATION,
  payload: data
});

export const EvaluationDetailSearchEvaluationSuccess = (message) => ({
  type: EVALUATION_DETAIL_SEARCH_EVALUATION_SUCCESS,
  payload: message
});

export const EvaluationDetailSearchEvaluationError = (error) => ({
  type: EVALUATION_DETAIL_SEARCH_EVALUATION_ERROR,
  payload: error
}); 

export const EvaluationDetailSearchAnswer = (data) => ({
  type: EVALUATION_DETAIL_SEARCH_ANSWER,
  payload: data
});

export const EvaluationDetailSearchAnswerSuccess = (message) => ({
  type: EVALUATION_DETAIL_SEARCH_ANSWER_SUCCESS,
  payload: message
});

export const EvaluationDetailSearchAnswerError = (error) => ({
  type: EVALUATION_DETAIL_SEARCH_ANSWER_ERROR,
  payload: error
}); 

export const EvaluationDetailSearchDocument = (data) => ({
  type: EVALUATION_DETAIL_SEARCH_DOCUMENT,
  payload: data
});

export const EvaluationDetailSearchDocumentSuccess = (message) => ({
  type: EVALUATION_DETAIL_SEARCH_DOCUMENT_SUCCESS,
  payload: message
});

export const EvaluationDetailSearchDocumentError = (error) => ({
  type: EVALUATION_DETAIL_SEARCH_DOCUMENT_ERROR,
  payload: error
}); 

export const EvaluationDetailAddChangeSet = (data) => ({
  type: EVALUATION_DETAIL_ADD_CHANGE,
  payload: data
});

export const EvaluationDetailAddSet = (data) => ({
  type: EVALUATION_DETAIL_ADD_SET,
  payload: data
});

export const EvaluationDetailAddModalSet = (data) => ({
  type: EVALUATION_DETAIL_ADD_MODAL_SET,
  payload: data
});

export const EvaluationDetailAdd = (data) => ({
  type: EVALUATION_DETAIL_ADD,
  payload: data
});

export const EvaluationDetailAddSuccess = (message) => ({
  type: EVALUATION_DETAIL_ADD_SUCCESS,
  payload: message
});

export const EvaluationDetailAddError = (error) => ({
  type: EVALUATION_DETAIL_ADD_ERROR,
  payload: error
});

export const EvaluationDetailDetail = (data) => ({
  type: EVALUATION_DETAIL_DETAIL,
  payload: data
});

export const EvaluationDetailDetailSuccess = (data) => ({
  type: EVALUATION_DETAIL_DETAIL_SUCCESS,
  payload: data
});

export const EvaluationDetailDetailError = (error) => ({
  type: EVALUATION_DETAIL_DETAIL_ERROR,
  payload: error
});

export const EvaluationDetailViewModalSet = (data) => ({
  type: EVALUATION_DETAIL_VIEW_MODAL_SET,
  payload: data
});

export const EvaluationDetailEditModalSet = (data) => ({
  type: EVALUATION_DETAIL_EDIT_MODAL_SET,
  payload: data
});

export const EvaluationDetailEditChangeSet = (data) => ({
  type: EVALUATION_DETAIL_EDIT_CHANGE,
  payload: data
});

export const EvaluationDetailUpdate = (data) => ({
  type: EVALUATION_DETAIL_UPDATE,
  payload: data
});

export const EvaluationDetailUpdateSuccess = (message) => ({
  type: EVALUATION_DETAIL_UPDATE_SUCCESS,
  payload: message.message
});

export const EvaluationDetailUpdateError = (error) => ({
  type: EVALUATION_DETAIL_UPDATE_ERROR,
  payload: error
});

export const EvaluationDetailViewTabSet = (data) => ({
  type: EVALUATION_DETAIL_VIEW_TAB_SET,
  payload: data
});

const evaluation_detail = (state) => state[NAME];

export const EvaluationDetailSelector = createStructuredSelector({
  evaluation_detail
})
 